import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Image, Table, Icon } from 'semantic-ui-react'
import nav_img from "../assets/home/nav_img.png";
import { useTranslation } from "react-i18next";


const AboutUs = () => {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const MeettheTeam = () => {
        return (

            <Grid>
                <Grid.Row>

                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>

                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>

                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>

                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={4}>
                        <div className="ankit">
                            <img className="nav_img" src={nav_img} />
                            <h5>Ankit Kumar</h5>
                            <p>Designer & Product Branding Manager</p>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }

    return (
        <>
            <div className="container-fluid bg clearall">
                <div className="allabout">

                    <h3>{t('about.about')} <span>{t('about.us')}</span></h3>
                    <h4>{t('about.title')}</h4>
                    <p>{t('about.subTitle')}</p>

                    <h3>Meet the <span>Team</span></h3>
                    <h4>Lorem ipsum dolor sit amet, consectetur</h4>

                
                    {MeettheTeam()}
                    {/* {/* Why Us? sec start*} */}

                    <h3>Why <span>Us?</span></h3>
                    <h4>Lorem ipsum dolor sit amet, consectetur</h4>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell />
                                <Table.HeaderCell className="no_border">Other Platforms</Table.HeaderCell>
                                <Table.HeaderCell className="no_border ">InstaStarz</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header> 

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Winners</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Just a simple video shoutouts & messages</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Assured meeting with the top tier Superstarz</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum is simply</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the </Table.Cell>

                            </Table.Row>
                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum is simply </Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum is </Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem I</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum is</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply</Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell className="table_border" width={2}>Lorem Ipsum is</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and</Table.Cell>
                                <Table.Cell className="table_border" width={7}>Lorem Ipsum is simply dummy text of the printing and typesetting</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>


            </div>



        </>
    );
};

export default AboutUs;
